import React from "react"

const RightBar = () => {
  return (
    <div className="fixed top-[479px] rotate-90 pr-1">
     <span className="flex flex-row space-x-7 items-center justify-center text-2xl text-customTeal tracking-widest font-bold roboto-regular">
      <a href="mailto:jalanansh2005@gmail.com">jalanansh2005@gmail.com"</a>
      <hr className="w-[103px] border-t-2 border-customGray"/>
      </span> 
    </div>
  )
};

export default RightBar;
